import { SESSION_FORMATS, SESSION_LENGTH_MINUTES } from './sessionPricing';

export const LISTENING_BIO_MAX = 500;
export const AVAILABILITY_NOTE_MAX = 200;
export const TALKING_BIO_MAX = 500;
export const TALKING_NOTE_MAX = 300;
export const DISPLAY_NAME_MAX = 60;
export const LOCKED_SESSION_MINUTES = SESSION_LENGTH_MINUTES;

export const PREFERRED_FORMAT_IDS = SESSION_FORMATS;

/**
 * Talker preferred formats. Stored on the user as publicData.preferredFormats.
 *
 * @param {*} value
 * @returns {Array<string>}
 */
export const normalizePreferredFormats = value => {
  const list = Array.isArray(value) ? value : typeof value === 'string' ? value.split(',') : [];
  const wanted = list.map(item => String(item || '').trim());
  return PREFERRED_FORMAT_IDS.filter(id => wanted.includes(id));
};

/**
 * Optional Listening availability note on the listing.
 *
 * @param {*} value
 * @returns {string}
 */
export const normalizeAvailabilityNote = value => {
  if (typeof value !== 'string') {
    return '';
  }
  return value.slice(0, AVAILABILITY_NOTE_MAX);
};

/**
 * Optional Talking “anything else” note on the user.
 *
 * @param {*} value
 * @returns {string}
 */
export const normalizeTalkingNote = value => {
  if (typeof value !== 'string') {
    return '';
  }
  return value.slice(0, TALKING_NOTE_MAX);
};

/**
 * Character count label. Spaces around the slash so “64 / 200” is not read as “64-man”.
 *
 * @param {string} [value]
 * @param {number} max
 * @returns {string}
 */
export const charCountLabel = (value, max) => `${String(value || '').length} / ${max}`;
